import { forwardRef } from "react";
import { type ButtonProps } from "react-aria-components";
import {
  CoreIconButton,
  type PropsWithOptionalTestID,
} from "@boi/components-core";

import * as S from "./IconButtonV2.styled";

export type IconButtonV2Props = PropsWithOptionalTestID &
  ButtonProps & {
    variant?: CoreIconButton.Variant;
  };

const IconButtonV2 = forwardRef<HTMLButtonElement, IconButtonV2Props>(
  (props, ref) => {
    const {
      variant = CoreIconButton.DEFAULT_VARIANT,
      children,
      testID = "icon-button",
      ...otherProps
    } = props;

    return (
      <S.Wrapper
        {...otherProps}
        ref={ref}
        $variant={variant}
        data-testid={testID}
      >
        {(renderProps) => (
          <S.InnerWrapper $variant={variant}>
            {typeof children === "function" ? children(renderProps) : children}
          </S.InnerWrapper>
        )}
      </S.Wrapper>
    );
  }
);

IconButtonV2.displayName = "IconButtonV2";

export default IconButtonV2;
